import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss'],
})
export class SignaturePadComponent implements AfterViewInit {
  @ViewChild('sigCanvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;

  private ctx!: CanvasRenderingContext2D;
  private drawing = false;
  private lastX = 0;
  private lastY = 0;
  private hasInk = false;

  ngAfterViewInit(): void {
    this.ctx = this.canvasRef.nativeElement.getContext('2d')!;
    this.setupCanvasForHiDPI();
    this.configurePen();
  }

  private setupCanvasForHiDPI() {
    const canvas = this.canvasRef.nativeElement;
    const rect = canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;

    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);

    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // Fondo blanco (si no, PNG con transparencia)
    this.ctx.fillStyle = '#fff';
    this.ctx.fillRect(0, 0, rect.width, rect.height);
  }

  private configurePen() {
    this.ctx.lineWidth = 2.5;
    this.ctx.lineCap = 'round';
    this.ctx.lineJoin = 'round';
    this.ctx.strokeStyle = '#111';
  }

  clear() {
    const canvas = this.canvasRef.nativeElement;
    const rect = canvas.getBoundingClientRect();
    this.ctx.clearRect(0, 0, rect.width, rect.height);
    this.ctx.fillStyle = '#fff';
    this.ctx.fillRect(0, 0, rect.width, rect.height);
    this.hasInk = false;
  }

  isEmpty(): boolean {
    return !this.hasInk;
  }

  hasSignature(): boolean {
    return this.hasInk;
  }

  onPointerDown(ev: PointerEvent) {
    ev.preventDefault();
    const { x, y } = this.getPos(ev);
    this.drawing = true;
    this.lastX = x;
    this.lastY = y;
    this.hasInk = true;
    this.ctx.beginPath();
    this.ctx.moveTo(x, y);
  }

  onPointerMove(ev: PointerEvent) {
    if (!this.drawing) return;
    ev.preventDefault();
    const { x, y } = this.getPos(ev);
    this.ctx.lineTo(x, y);
    this.ctx.stroke();
    this.lastX = x;
    this.lastY = y;
    this.hasInk = true;
  }

  onPointerUp(ev: PointerEvent) {
    if (!this.drawing) return;
    ev.preventDefault();
    this.drawing = false;
    this.hasInk = true;
    this.ctx.closePath();
  }

  private getPos(ev: PointerEvent) {
    const canvas = this.canvasRef.nativeElement;
    const rect = canvas.getBoundingClientRect();
    return { x: ev.clientX - rect.left, y: ev.clientY - rect.top };
  }

  // Exportar como Blob (ideal para FormData)
  async toPngBlob(): Promise<Blob> {
    const canvas = this.canvasRef.nativeElement;
    return new Promise((resolve, reject) => {
      canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('No blob'))), 'image/png', 1);
    });
  }

  // Si quieres base64:
  toDataUrl(): string {
    return this.canvasRef.nativeElement.toDataURL('image/png');
  }

  // Si el usuario rota / cambia tamaño, reescala
  @HostListener('window:resize')
  onResize() {
    // OJO: si reescalas, pierdes el dibujo. En producción se puede “congelar” a imagen y reinyectar.
    // Para la mayoría de casos en móvil, basta con fijar alto/ancho y evitar resize.
  }
}
